// extracted by mini-css-extract-plugin
export default {"sideNavbar":"SideNavbar_sideNavbar__GwjHe","searchInput":"SideNavbar_searchInput__GUXoM","navbarList":"SideNavbar_navbarList__q+KZ4"};